import {IServiceAction} from "redux-request-middleware";
import {
  addLoading,
  removeLoading,
  isRequestAction,
  getLoadingAction,
  LoadingActionType,
  cleanAction,
} from "redux-request-middleware/utils";

export interface IState {
  loading: Array<IServiceAction<any, any, any, any>>;
}

let currentLoadings: Array<IServiceAction<any, any, any, any>> = [];
const defaultState: IState = {
  loading: [],
};

export default function reducer(state: IState = defaultState, action: IServiceAction<any, any, any, any>): IState {
  const mState = {...state};
  if (isRequestAction(action)) {
    const mAction = cleanAction(action);
    const loadingActionType = getLoadingAction(action.type);
    if (loadingActionType === LoadingActionType.ADD) {
      mState.loading = addLoading(state.loading, mAction as IServiceAction<any, any, any, any>);
    } else if (loadingActionType === LoadingActionType.REMOVE) {
      mState.loading = removeLoading(state.loading, mAction as IServiceAction<any, any, any, any>);
    }
  }
  currentLoadings = mState.loading;
  return mState;
}

export function getCurrentLoadings(): Array<IServiceAction<any, any, any, any>> {
  return currentLoadings;
}
